import React, { FC, Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Form, Input, Button, Alert, Row, Col, Spin, Select, notification } from "antd";
import Layout from "@layout/auth";
import { appInsights, reactPlugin, withAITracking } from "../../../appInsights";
import RestrictedEye from "@assets/RestrictedEye.png";
import UnrestrictedEye from "@assets/UnrestrictedEye.png";
import { ACCOUNT_BLOCKED, PASSWORD_EXPIRED_TITLE, PASSWORD_EXPIRED_DESCRIPTION, PASSWORD_EXPIRY, VALIDATION } from "@utils/messages";
import { routeMap } from "@utils/constants";
import "./login.scss";
import Link from "@components/link";
import authService from "@services/auth.service";
import storageService from "@services/storage.service";
import sessionService from "@services/session.service";
import { get } from "@utils/axios";
import IconChevron from "@assets/icon_chevron.svg";
import useSession from "@utils/useSession";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { useConfigStore } from "@stores/useConfigStore";
import { createMSALInstance } from "@utils/msal";
import { createOktaInstance } from "@utils/okta";
import { getPasswordSecret } from "@utils/helpers";
import { useIdleTimerContext } from "react-idle-timer";
import { useFont } from "@context/fontProvider";
import { useMemberListStore } from "@stores/useMemberListStore";

var CryptoJS = require("crypto-js");

const initialValues = {
  email: "",
  password: "",
  consentApproved: false,
  code: "",
  secret: "",
};

const errorMessages = {
  required: VALIDATION.required,
  types: {
    email: VALIDATION.email,
  },
};

export interface IClient {
  clientName: string;
  appServiceUrl: string;
  domainName: string;
  domain_id: string;
  mfaEnabled: string | null;
  is_sso: string;
  sub_domain?: string;
  clientId?: string;
  authority?: string;
  provider?: string;
}

const LoginPage: FC<any> = ({ history }: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  const idleTimer = useIdleTimerContext();
  const config = useConfigStore((state) => state.config);
  const fetchConfig = useConfigStore((state) => state.fetchConfig);

  const [form] = Form.useForm();
  const [credentials, setCredentials] = useState(initialValues);
  const [isSSO, setIsSSO] = useState(false);
  const [failedCount, setFailedCount] = useState(0);
  const [expireInDays, setExpireInDays] = useState(3);
  const [domains, setDomains] = useState<IClient[]>([]);
  const [selectBoxOptions, setselectBoxOptions] = useState<IClient[]>([]);
  // const [client, setClient] = useState<IClient | undefined>();
  const client = useGlobalInformationStore((state) => state.client);
  const setClient = useGlobalInformationStore((state) => state.setClient);
  const [loader, setLoader] = useState(false);
  const [selectedClient, setSelectedClient] = useState<string | undefined>();
  const [showClientDropdown, setShowClientDropdown] = useState<boolean>(false);
  const { Option } = Select;
  const [type, setType] = useState("password");
  const [showConsent, setshowConsent] = useState<boolean>(false);
  const [showmfa, setshowmfa] = useState<boolean>(false);
  const [mfaEnabled, setmfaEnabled] = useState<boolean>(false);
  const [newmfa, setnewmfa] = useState<boolean>(false);
  const [qrcodemfa, setqrcodemfa] = useState<string>("");
  const [codenumbers, setcodenumbers] = useState<Array<string | undefined>>([]);
  const isSSORedirect: boolean = location.pathname === "/auth/sso-redirect";
  const url = new URL(window.location.href);
  const hostchunks = url.host.split(".");
  const [host, subdomain] = hostchunks.splice(0, 2).reverse();
  const [ext] = hostchunks;

  const { changeFontFamily } = useFont();

  useEffect(
    () => {
      console.log("LoginPage.useEffect1");
      let code = codenumbers.join("");
      if (code.length < 6) {
        code = "";
      }
      form.setFieldsValue({ code: code });
      credentials.code = code;
      onValueChange({ code }, { ...credentials });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [codenumbers.join("")]
  );

  function onValueChange(changes: any, values: any) {
    console.log("LoginPage.onValueChange");
    let domain: string = changes ? changes?.email?.split("@")[1] : values?.email ? values?.email?.split("@")[1] : null;
    if (domain) {
      let found = false;
      domains.forEach((d) => {
        if (domain === d.domainName) {
          setClient(d);
          setmfaEnabled(d.mfaEnabled === "T");
          setSelectedClient(d.domainName);
          setIsSSO(d.is_sso === "Y");
          found = true;
        }
      });
      if (!found) {
        setShowClientDropdown(false);
        setClient(undefined);
        setmfaEnabled(false);
        setSelectedClient(undefined);
        setIsSSO(false);
      }
    }
    setCredentials({
      ...credentials,
      ...values,
    });
  }

  useEffect(() => {
    console.log("LoginPage.useEffect2");
    if (showmfa && newmfa && client && !credentials.secret) {
      authService
        .getmfaqrcode(
          {
            email: credentials.email,
          },
          client
        )
        .subscribe({
          next: (v) => {
            let qrcode = v.data?.data?.url;
            let secret = v.data?.data?.secret;
            setCredentials({
              ...credentials,
              secret,
            });
            setqrcodemfa(qrcode);
          },
        });
    }
  }, [showmfa, newmfa, credentials]);

  // useEffect(() => {
  // instance.acquireTokenSilent(
  //   {
  //     scopes: ["user.read"],
  //   }
  // ).then(e => console.log('sso', e))
  // .catch(e => console.log('sso', e))
  // }, []);

  function login(client: any, credentials: any) {
    let userId = credentials.email;
    const encryptedPassword = CryptoJS.AES.encrypt(credentials.password, getPasswordSecret()).toString();
    return authService.healthCheck(client).subscribe({
      next: (v) => {
        authService
          .login(
            {
              email: userId,
              password: encryptedPassword,
              consentApproved: credentials.consentApproved,
              code: credentials.code,
              secret: credentials.secret,
              mfaEnabled,
              domainId: client.domainId,
              isSSO: client.is_sso
            },
            client
          )
          .subscribe({
            next: (v) => {
              useConfigStore.getState().clearStore();
              if (v.data && v.data.data && v.data.data.user && !v.data.data.user.consentApproved) {
                setshowConsent(true);
                setshowmfa(false);
                return;
              } else if (!credentials.code && mfaEnabled) {
                setshowmfa(true);
                setshowConsent(false);
                (document.querySelector(".input-group-code input") as any).focus();
                if (!v.data?.data?.user?.mfa_secret) {
                  setnewmfa(true);
                } else {
                  setnewmfa(false);
                }
                return;
              }
              if (v?.data && v?.data?.data?.user && v?.data?.data?.accessToken && v?.data?.data?.accessToken !== "" && v?.data?.data?.refreshToken !== "") {
                handleLoginSuccess(v.data, client);
                appInsights.setAuthenticatedUserContext(userId);
                appInsights.trackEvent({ name: `${v.data.data.user.email} Logged on tab ${idleTimer?.getTabId()}`, properties: { isLeader: idleTimer?.isLeader() } });
                appInsights.trackPageView({ name: "Login" });
              }
            },
            error: (e) => {
              const responseData = e?.response?.data?.data;
              if (responseData?.isResetRequired && responseData?.resetUrl) {
                setTimeout(()=> {
                  window.location.href = responseData.resetUrl;
                }, 1500)
                return;
              }

              setFailedCount(1);
              setLoader(false);
              setCredentials({ ...initialValues });
              navigate(routeMap["login"]);
            },
            complete: () => setLoader(false),
          });
      },
      error: (e) => {
        console.log(e);
        setLoader(false);
        notification.error({
          message: "Error",
          description: "Backend services are not accessible/available. Please check if you are connected to VPN, if applicable, otherwise please contact your IT Admin",
        });
      },
    });
  }

  function ssoLogin(client: IClient) {
    if (client.provider === "azure") {
      const instance = createMSALInstance(client);
      return instance
        .handleRedirectPromise()
        .then((data: any) => {
          if (!data) {
            instance
              .loginRedirect({
                scopes: [],
                redirectUri: "/auth/login",
              })
              .catch((error) => {
                setLoader(false);
              });
          }

          let email = data?.account?.username;
          if (email) {
            let newCredentials = {
              ...credentials,
              email,
              password: "ProductTest@123",
            };
            setCredentials(newCredentials);
            return login(client, newCredentials);
          }
        })
        .catch((e) => {
          return instance
            .loginRedirect({
              scopes: [],
              redirectUri: "/auth/login",
            })
            .catch((error) => {
              setLoader(false);
            });
        });
    }
    if (client.provider === "okta") {
      const instance = createOktaInstance(client);

      return instance.token
        .parseFromUrl()
        .then((response: any) => {
          const { tokens } = response;
          const { idToken } = tokens;
          if (idToken != null) {
            const { claims, idToken: token } = idToken;
            const { preferred_username: email } = claims;
            if (email) {
              let newCredentials = {
                ...credentials,
                email,
                password: "ProductTest@123",
              };
              setCredentials(newCredentials);
              return login(client, newCredentials);
            }
          }
        })
        .catch((e: any) => {
          return instance.signInWithRedirect({
            originalUri: "/",
          });
        });
    }
  }

  function onSubmit() {
    console.log("LoginPage.submit.form");
    setLoader(true);
    if(!client && domains?.length > 0) {
      const email:any = credentials?.email;
      let domain: any = email ? credentials?.email?.split("@")[1] : null;
      let clientObj:any;
      let found = false;
      if (domain) {
        domains?.forEach((d) => {
          if (domain === d.domainName) {
            clientObj = d;
            setClient(d);
            setmfaEnabled(d.mfaEnabled === "T");
            setSelectedClient(d.domainName);
            setIsSSO(d.is_sso === "Y");
            found = true;
          }
        });
        if (!found) {
          setShowClientDropdown(true);
          // setClient(undefined);
          setmfaEnabled(false);
          setSelectedClient(undefined);
          setIsSSO(false);
          setLoader(false);
        }
      }
      if(found) {
        setCredentials({
          ...credentials,
        });
        loginHandler(credentials, clientObj)
      }
    } else if (client && domains?.length > 0) {
      loginHandler();
    }
    else {
      setLoader(false);
    }
  }

  function loginHandler(creds?:any, clientObj?: any) {
    const tempClientObj = client || clientObj;
    if(tempClientObj) {
      if (isSSO && !creds.password) {
        if (subdomain !== tempClientObj.sub_domain) {
          window.location.href = ["https://", [tempClientObj.sub_domain, host, ext].filter((i) => !!i).join(".")].join("");
          return;
        }
        return ssoLogin(tempClientObj);
      }
      return login(tempClientObj, credentials);
    }
  }

  const onClientChange = (domain: string) => {
    setSelectedClient(domain);
    domains?.forEach((d) => {
      if (domain === d.domainName) {
        setClient(d);
        setmfaEnabled(d.mfaEnabled === "T");
        setIsSSO(d.is_sso === "Y");
      }
    });
  };

  function handleLoginSuccess(response: any, client: any): void {
    setLoader(false);
    storageService.set("_token", response.data.accessToken);
    storageService.set("_refreshToken", response.data.refreshToken);
    storageService.set("_user", response.data.user);
    storageService.set("_client", client);
    sessionService.afterLogin();
    fetchConfig();
    if(client?.clientName === 'Centric')  {
      changeFontFamily("Roboto");
      // for centric we need 10 rows in mem list. 
      useMemberListStore.getState().clearStore();
    } ;
  }

  useEffect(() => {
    console.log("LoginPage.useEffect3");
    const params = new URLSearchParams(location.search);
    if (params.get("sso") === "true") {
      setIsSSO(true);
    } else {
      setIsSSO(false);
    }
  }, [location.search]);

  useEffect(() => {
    console.log("LoginPage.useEffect4");
    fetchDomains();
  }, []);

  /**
   * Function to fetch all domains/clients app url from database
   */
  const fetchDomains = async () => {
    console.log("LoginPage.fetchDomains");
    let forcedLogout = sessionStorage.getItem("forcedLogout") === "true";
    sessionStorage.removeItem("forcedLogout");
    get(`${process.env.REACT_APP_API_BASE_URI}/domain/domains`).subscribe({
      next: (v: any) => {
        let domains = []
        try {
          let domainsE = v?.data?.data?.domains

          let domainsD = CryptoJS.AES.decrypt(
            domainsE,
            getPasswordSecret()
          );
          let domainsS = domainsD.toString(CryptoJS.enc.Utf8);
          domains = JSON.parse(
            domainsS
          )
        } catch (e) {
          console.log(e)
          domains = []
        }

        const domainsData = domains?.map((d: any) => {
          return {
            clientName: d.client_name,
            domainName: d.user_domain_name,
            appServiceUrl: d.app_service_url,
            mfaEnabled: d.mfa_enablement_flag,
            is_sso: d.is_sso,
            sub_domain: d.sub_domain,
            clientId: d.client_id,
            authority: d.authority,
            provider: d.provider,
            domainId: d.domain_id
          };
        });
        let tempSelectOptions: any[] = [];
        let pushedClientsMap: any[] = [];
        domainsData.forEach((d: any) => {
          if (!pushedClientsMap.includes(d.clientName)) {
            tempSelectOptions.push(d);
            pushedClientsMap.push(d.clientName);
          }
        });
        const client = domainsData?.find((d: any) => d.sub_domain === subdomain);
        if (client && client.is_sso) {
          setClient(client);
          if (!forcedLogout) {
            setLoader(true);
            ssoLogin(client);
          }
        }
        setselectBoxOptions(tempSelectOptions);
        setDomains(domainsData);
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  /**
   * UseEffect for redirecting when user is already logged in
   */

  const session = useSession();

  useEffect(() => {
    console.log("LoginPage.useEffect5");
    if (session.isLoggedIn && config?.role) {
      appInsights.setAuthenticatedUserContext(sessionService?.getUser()?.email);
      let sessionRedirectURL = sessionStorage.getItem("redirectURL");
      if (sessionRedirectURL) {
        sessionStorage.removeItem("redirectURL");
        navigate(sessionRedirectURL);
        return;
      }
      if (config?.role === "HighIntensityUser") {
        navigate(routeMap["care-lite"]);
      } else if (sessionService?.getClient()?.clientName === "Marquee" || sessionService?.getClient()?.clientName === "SightMD") {
        navigate(routeMap["dashboard"]);
      } else if (sessionService?.getClient()?.clientName === "Wellbe") {
        navigate(routeMap["dashboard"]);
      } else {
        navigate(routeMap["members"]);
      }
    }
  }, [session]);

  const passwordTypeToggle = () => {
    type === "password" ? setType("text") : setType("password");
  };

  const onCancel = () => {
    setshowmfa(false);
    setnewmfa(false);
    setshowConsent(false);
    setcodenumbers([]);
    form.resetFields();
    const values = { email: credentials.email };
    form.setFieldsValue(values);
    onValueChange(values, values);
  };

  return (
    <Layout className={showmfa || showConsent ? "hide-footer" : ""}>
      <Row>
        <Col span={24}>
          <div className="auth-alerts">
            <div className="alerts">
              {failedCount > 3 && (
                <Alert
                  description={<span className="clr-n100 f16 w500">{ACCOUNT_BLOCKED}</span>}
                  type="error"
                  showIcon
                  closable
                  icon={<span className="icon-alert-triangle" style={{ marginTop: "4px" }} />}
                />
              )}
              {expireInDays < 3 && (
                <Alert
                  type="warning"
                  showIcon
                  icon={<span className="icon-alert-triangle" />}
                  description={<span className="clr-n100 f16 w500">{PASSWORD_EXPIRY}</span>}
                  action={
                    <div>
                      <Button size="small" type="text" onClick={() => setExpireInDays(Infinity)}>
                        Later
                      </Button>
                      <Button size="small" type="link" onClick={() => navigate(routeMap["reset-password"])}>
                        Reset Now
                      </Button>
                    </div>
                  }
                />
              )}

              {expireInDays < 3 && (
                <Alert
                  type="error"
                  message={<span className="clr-n100 f16 w500">{PASSWORD_EXPIRED_TITLE}</span>}
                  showIcon
                  description={
                    <div>
                      <span className="clr-n75">{PASSWORD_EXPIRED_DESCRIPTION}</span>
                      <div style={{ marginTop: "8px" }}>
                        <Button className="p0" size="small" type="link" onClick={() => navigate(routeMap["reset-password"])}>
                          Reset Now
                        </Button>
                      </div>
                    </div>
                  }
                  icon={<span className="icon-alert-triangle" style={{ marginTop: "4px" }} />}
                />
              )}
            </div>
          </div>
        </Col>
      </Row>
      <Row style={{ display: showConsent ? "block" : "none" }}>
        <Col span={14} className="consent-screen">
          <div className="logo"></div>
          <div className="main-content">
            <div className="title">
              <h1>Terms and Conditions</h1>
            </div>
            <div className="terms">
              <p>
                <span>Company Technology:</span> Subscriber acknowledges that HEALTHEM.AI Inc., (“Company,” “we,” “us,” or “our”) retains all right, title and interest in and to the Company System,
                Documentation and all software and all Company proprietary information and technology used by Company or provided to Subscriber in connection with the Company Service (the “Company
                Technology”), and that the Company Technology is protected by Intellectual Property Rights owned by or licensed to Company. Other than as expressly set forth in this notice, no license
                or other rights in the Company Technology are granted to Subscriber. Subscriber hereby grants to Company a royalty-free, worldwide, transferable, sublicensable, irrevocable, perpetual
                license to use or incorporate into the Company Service any suggestions, enhancement requests, recommendations or other feedback provided by Subscriber, including Authorized Users,
                relating to the Company Service. Company shall not identify Subscriber as the source of any such feedback.
              </p>
              <p>
                <span>Right to Monitor:</span> Subscriber acknowledges that by accessing and using this software, Subscriber is consenting to usage monitoring towards information security and privacy
                policy compliance, law enforcement and other purposes. Unauthorized use of this system may subject to relevant disciplinary proceedings.
              </p>
              <p>
                <span>Subscriber Content:</span> The Subscriber Content hosted by Company as part of the Company Service, and all worldwide Intellectual Property Rights therein, is the exclusive
                property of Subscriber. Subscriber hereby grants to Company a non-exclusive, worldwide, royalty-free and fully paid license (a) to use the Subscriber Content as necessary for purposes
                of providing the Company Service to Subscriber, and (b) to use the Subscriber trademarks, service marks, and logos as required to provide the Company Service to Subscriber. All rights
                in and to the Subscriber Content not expressly granted to Company in this Agreement are reserved by Subscriber.
              </p>
              <p>
                <span>Third Party Software:</span> The Company Service may utilize, contain or otherwise use certain third party software, including open source or free software (collectively, the
                “Third Party Software”). Third Party Software may be subject to additional licensing terms, which Company may deliver or make available from time to time to Subscriber, which are
                incorporated herein by reference, and which supersede any contradictory terms in this Agreement.
              </p>
              <p>
                <span>Restrictions:</span> Subscriber will not, and will not permit any Authorized User or other party to: (a) use the Company Service to harvest, collect, gather or assemble
                information or data regarding other Company subscribers without their consent; (b) access or copy any data or information of other Company subscribers without their consent; (c)
                knowingly interfere with or disrupt the integrity or performance of the Company Service or the data contained therein; (d) harass or interfere with another Company subscriber’s use and
                enjoyment of the Company Service; (e) reverse engineer, disassemble or decompile any component of the Company System; (f) interfere in any manner with the operation of the Company
                Service, or the Company System or the hardware and network used to operate the Company Service; (g) sublicense any of Subscriber’s rights under this Agreement, or otherwise use the
                Company Service for the benefit of a third party or to operate a service bureau; (h) modify, copy or make derivative works based on any part of the Company System; or (i) otherwise use
                the Company Service in any manner that exceeds the scope of use permitted under this Agreement. Subscriber acknowledges and agrees that the Company Service will not be used, and are
                not licensed for use, in connection with any of Subscriber’s time-critical or mission-critical functions.
              </p>
              <p>
                BY ACCEPTING THESE TERMS AND CONDITIONS, YOU ACKNOWLEDGE AND AGREE THAT YOU HAVE READ, UNDERSTAND, AND AGREE TO BE BOUND BY THESE TERMS AND CONDITIONS. IF YOU DO NOT AGREE TO BE BOUND
                BY THESE TERMS AND CONDITIONS, YOU MAY NOT ACCESS OR USE THE COMPANY SERVICE
              </p>
            </div>
            <div className="actions">
              <Row>
                <Col>
                  <Button size="large" type="default" htmlType="button" onClick={onCancel}>
                    Cancel
                  </Button>
                </Col>
                <Col className="ml-auto">
                  <Spin spinning={loader} indicator={<HealthemSpinner />}>
                    <Button
                      size="large"
                      type="primary"
                      htmlType="submit"
                      onClick={() => {
                        credentials.consentApproved = true;
                        onSubmit();
                      }}
                    >
                      Agree
                    </Button>
                  </Spin>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
      <Row style={{ display: !showConsent ? "block" : "none" }}>
        <Col span={14} className={`m-auto login-wrapper ${showmfa && newmfa ? "mfa-login" : ""}`}>
          <div className="auth-login">
            <div className="logo"></div>
            {isSSORedirect ? (
              <div className="sso-login-redirect">
                <div className="sso-login-spin">
                  <Spin spinning={isSSORedirect} indicator={<HealthemSpinner />}></Spin>
                </div>
                <div className={`sso-loading_text w700`}>Page is redirecting ...</div>
              </div>
            ) : (
              <div>
                <h1 className="w700">Log In</h1>

                <Form name="loginForm" className="form" layout="vertical" form={form} initialValues={initialValues} validateMessages={errorMessages} onValuesChange={onValueChange} onFinish={onSubmit}>
                  <div className="mfa-form" style={{ display: showmfa ? "flex" : "none" }}>
                    {newmfa && (
                      <div className="new-mfa-form">
                        <p className="mfa-instructions">
                          To authorize you need to scan this QR Code with any one of Authenticator App (Google Authenticator, Microsoft Authenticator, etc.) and enter the verification code below.
                          <br />
                          This will be one time activity required during account setup
                        </p>
                        <div className="mfa-qrcode">
                          <img src={qrcodemfa} alt="" />
                        </div>
                      </div>
                    )}
                    {!newmfa && <p className="mfa-instrctions">Enter the code from Authenticator app on your mobile device​</p>}
                    <Form.Item label="Code" name="code" className="input-group-code" rules={[{ required: showmfa }]}>
                      {new Array(6).fill(0).map((_, i) => {
                        return (
                          <Input
                            key={`input-group-code${i}`}
                            type="text"
                            value={codenumbers[i] || ""}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            onKeyUp={(e) => {
                              if (e.key === "Backspace" || e.key === "Delete") {
                                const prevIndex = i > 0 ? i - 1 : 0;
                                (document.querySelectorAll(".input-group-code input")[prevIndex] as any).focus();
                              }
                            }}
                            onInput={(e) => {
                              const value = parseInt(e.currentTarget.value);
                              codenumbers[i] = ((isFinite(value) ? value : "") + "").slice(-1) || undefined;
                              setcodenumbers([...codenumbers]);
                              if (codenumbers[i]) {
                                const nextIndex = i < 5 ? i + 1 : 5;
                                (document.querySelectorAll(".input-group-code input")[nextIndex] as any).focus();
                              }
                            }}
                          />
                        );
                      })}
                    </Form.Item>
                    <Row justify="space-between">
                      <Button size="large" type="default" htmlType="button" onClick={onCancel}>
                        Cancel
                      </Button>
                      <Spin spinning={loader} indicator={<HealthemSpinner />}>
                        <Button size="large" type="primary" htmlType="submit" disabled={!form.isFieldsTouched() || form.getFieldsError().filter((field) => field.errors.length > 0).length > 0}>
                          Continue
                        </Button>
                      </Spin>
                    </Row>
                  </div>
                  <div style={{ display: showmfa ? "none" : "block" }}>
                    <Form.Item label="Email Address" name="email" className="fr" rules={[{ required: true }, { type: "email" }]}>
                      <Input
                        onBlur={() => {
                          if (!client) {
                            setShowClientDropdown(true);
                          }
                        }}
                        type="email"
                        placeholder="name@company.com"
                        size="large"
                      />
                    </Form.Item>

                    {showClientDropdown && (
                      <Form.Item label="Select Organization" name="client" className="fr" rules={[{ required: true }, { type: "string" }]}>
                        <Select
                          className="ui-select"
                          style={{ width: "100%", fontSize: 16 }}
                          placeholder="Select organization"
                          optionFilterProp="children"
                          onChange={onClientChange}
                          onSearch={() => {}}
                          value={selectedClient}
                          suffixIcon={
                            <span>
                              <img src={IconChevron} alt="chevron-icon" />
                            </span>
                          }
                        >
                          {selectBoxOptions?.map((domain) => {
                            return (
                              <Option key={domain.domainName} value={domain.domainName} className="filters-row-option">
                                {domain.clientName}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    )}

                    {client?.is_sso === "Y" ? (
                      <Spin spinning={loader} indicator={<HealthemSpinner />}>
                        <Button size="large" type="primary" htmlType="submit" block disabled={domains?.length === 0 || !form.isFieldsTouched() || form.getFieldsError().filter((field) => field.errors.length > 0).length > 0}>
                          Continue
                        </Button>
                      </Spin>
                    ) : (
                      <Fragment>
                        <Form.Item label="Password" name="password" className="fr" rules={[{ required: true }]}>
                          <Input
                            placeholder="Enter password"
                            size="large"
                            type={type}
                            suffix={
                              <div
                                className="password-eye"
                                onMouseDown={passwordTypeToggle}
                                onMouseUp={passwordTypeToggle}
                                onMouseOut={() => setType("password")}
                                // onMouseEnter={() => setType("text")}
                                // onMouseLeave={() => setType("password")}
                              >
                                <img src={type === "password" ? RestrictedEye : UnrestrictedEye} alt="" />
                                {/* 
                          <Icon
                            name={
                              type === "password"
                                ? "eye-restricted"
                                : "eye-non-restricted"
                            }
                          /> */}
                              </div>
                            }
                          />
                        </Form.Item>

                        <div className="fr">
                          <div className="wr">
                            <Link text="Forgot Password?" className="w500" link={routeMap["forgot-password"]} propState={{ email: credentials.email }} />

                            <Spin spinning={loader} indicator={<HealthemSpinner />}>
                              <Button size="large" type="primary" htmlType="submit" disabled={!form.isFieldsTouched() || form.getFieldsError().filter((field) => field.errors.length > 0).length > 0}>
                                Continue
                              </Button>
                            </Spin>
                          </div>
                        </div>
                      </Fragment>
                    )}
                  </div>

                  <div className="fr">
                    <p className="tc clr-n75">Contact your Admin for help</p>
                  </div>
                </Form>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Layout>
  );
};

export default withAITracking(reactPlugin, LoginPage);
